import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CurrentAccountsListComponent } from "./current-accounts-list/current-accounts-list.component";
import { CurrentAccountsDetailsComponent } from "./current-accounts-detail/current-accounts-detail.component";

const currentAccountsRoutes: Routes = [
  {
    path: "",
    component: CurrentAccountsListComponent,
  },
  { path: "reset", redirectTo: "current-account", pathMatch: "prefix" },
  {
    path: "current-account",
    component: CurrentAccountsDetailsComponent,
  },
  {
    path: "current-account/:token",
    component: CurrentAccountsDetailsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(currentAccountsRoutes)],
  exports: [RouterModule],
})
export class CurrentAccountsRoutingModule {}
